import { AHButton, AHText, Box } from "arkh";
import React, { useCallback } from "react";
import {
  StoreAdminNavigationScreenProps,
  StoreAdminNavigationProp,
} from "../../StoreAdmin/StoreAdminNavigation";
import { Lottie } from "../../../components/Lottie";
import { Path, Rect, Svg } from "react-native-svg";
import { FormattedMessage, useIntl } from "react-intl";

export const AddScreen = (
  props: StoreAdminNavigationScreenProps<"AddScreen">
) => {
  return (
    <AddScreenComponent
      navigation={props.navigation}
      params={props.route.params}
    />
  );
};

export const AddScreenComponent = (props: {
  navigation: StoreAdminNavigationProp<any>;
  params?: StoreAdminNavigationScreenProps<"AddScreen">["route"]["params"];
}) => {
  const intl = useIntl();

  const onStartScanning = useCallback(() => {
    props.navigation.navigateDeprecated("AddScreenScanQR", {
      userCode: props.params?.userCode,
      fromStorecast: props.params?.fromStorecast,
    });
  }, [props.navigation, props.params?.userCode, props.params?.fromStorecast]);

  return (
    <Box space="large" style={{ flex: 1 }}>
      <Box spaceBottom="xsmall" style={{ alignItems: "center" }}>
        <Svg width="36" height="33" viewBox="0 0 36 33" fill="none">
          <Rect
            x="1.875"
            y="1.125"
            width="33"
            height="26.25"
            rx="4.125"
            stroke="#374151"
            stroke-width="2.25"
          />
          <Path
            d="M12.75 31.5H24.75"
            stroke="#374151"
            stroke-width="2.25"
            stroke-linecap="round"
          />
        </Svg>
      </Box>
      <AHText type="title-big" textAlign="center">
        <FormattedMessage
          description="Storecast admin add screen intro title"
          defaultMessage="Install a new screen"
        />
      </AHText>
      <AHText spaceTop="large" type="list-item-title">
        <FormattedMessage
          description="Storecast admin add screen intro subtitle"
          defaultMessage="Go to storecast.app in the TV's web browser before proceeding to the next step."
        />
      </AHText>

      <Box spaceTop="large" />
      <Box style={{ width: "100%", flex: 1, alignItems: "center" }}>
        <Lottie
          autoPlay
          loop
          source={require("./scan-qr.json")}
          autoSize
          style={{ width: "100%", maxHeight: "100%" }}
        />
      </Box>

      <Box spaceHorizontal="large">
        <AHButton
          onPress={onStartScanning}
          themeType="primary"
          title={intl.formatMessage({
            description: "Storecast admin add screen button label",
            defaultMessage: "Scan the QR-code",
          })}
          iconRight
          iconType="camera"
        />
      </Box>
    </Box>
  );
};
